module.exports = __webpack_public_path__ + "img/coupon_red.png?v=f049ee34";